import { createBrowserRouter } from 'react-router-dom'
import { RootLayout } from './layouts/RootLayout'
import { DashboardLayout } from './layouts/DashboardLayout'
import { ProtectedRoute } from './components/common/ProtectedRoute'

// Pages
import { HomePage } from './pages/HomePage'
import { SignInPage } from './pages/SignInPage'
import { SignUpPage } from './pages/SignUpPage'
import { AuthCallbackPage } from './pages/AuthCallbackPage'

// Dashboard pages
import { DashboardPage } from './pages/dashboard/DashboardPage'
import { UsersPage } from './pages/dashboard/UsersPage'
import { UserProfilePage } from './pages/dashboard/UserProfilePage'
import { UserSecurityPage } from './pages/dashboard/UserSecurityPage'
import { UserSessionsPage } from './pages/dashboard/UserSessionsPage'
import { OrganizationSwitcherPage } from './pages/dashboard/OrganizationSwitcherPage'

// Settings pages
import { AgentSettingsPage } from './pages/settings/AgentSettingsPage'
import { CompanySettingsPage } from './pages/settings/CompanySettingsPage'
import { KnowledgeSettingsPage } from './pages/settings/KnowledgeSettingsPage'
import { BillingSettingsPage } from './pages/settings/BillingSettingsPage'
import { IntegrationsSettingsPage } from './pages/settings/IntegrationsSettingsPage'

// Agents pages
import { AgentsListPage } from './pages/agents/AgentsListPage'
import { AgentsActionsPage } from './pages/agents/AgentsActionsPage'
import { AgentsKnowledgePage } from './pages/agents/AgentsKnowledgePage'

import { NotFoundPage } from './pages/NotFoundPage'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <NotFoundPage />,
    children: [
      // Public routes
      { index: true, element: <HomePage /> },
      { path: 'sign-in', element: <SignInPage /> },
      { path: 'sign-up', element: <SignUpPage /> },
      { path: 'auth/callback', element: <AuthCallbackPage /> },

      // Protected dashboard routes
      {
        path: 'dashboard',
        element: (
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        ),
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'users', element: <UsersPage /> },
          { path: 'user-profile', element: <UserProfilePage /> },
          { path: 'user-security', element: <UserSecurityPage /> },
          { path: 'user-sessions', element: <UserSessionsPage /> },
          {
            path: 'organization-switcher',
            element: <OrganizationSwitcherPage />,
          },
        ],
      },

      // Protected settings routes
      {
        path: 'settings',
        element: (
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        ),
        children: [
          { path: 'agent', element: <AgentSettingsPage /> },
          { path: 'company', element: <CompanySettingsPage /> },
          { path: 'knowledge', element: <KnowledgeSettingsPage /> },
          { path: 'billing', element: <BillingSettingsPage /> },
          { path: 'integrations', element: <IntegrationsSettingsPage /> },
        ],
      },

      // Protected agents routes
      {
        path: 'agents',
        element: (
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        ),
        children: [
          { path: 'list', element: <AgentsListPage /> },
          { path: 'actions', element: <AgentsActionsPage /> },
          { path: 'knowledge', element: <AgentsKnowledgePage /> },
        ],
      },
    ],
  },
])
